function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/* SVGR has dropped some elements not supported by react-native-svg: title */
import * as React from 'react';
import { memo } from 'react';
import Svg, { Path } from 'react-native-svg';
const CaretDown = props => /*#__PURE__*/React.createElement(Svg, _extends({
  width: 24,
  height: 13
}, props), /*#__PURE__*/React.createElement(Path, {
  d: "M24 .867c0 .23-.09.45-.251.612L12.6 12.746a.853.853 0 0 1-1.213 0L.241 1.48A.873.873 0 0 1 .03.65.862.862 0 0 1 .63.04a.851.851 0 0 1 .822.213l10.542 10.654L22.535.254a.853.853 0 0 1 1.213 0c.161.162.252.383.252.613Z",
  fill: "#1D3146",
  fillRule: "nonzero"
}));
const CaretDownIcon = /*#__PURE__*/memo(CaretDown);
export default CaretDownIcon;
//# sourceMappingURL=index.js.map